<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">应急组织结构</div>
      <el-form class="zj-search-form" ref="form" :model="form">
        <el-form-item label="所属应急组织类型">
          <el-select v-model="EmergencyType" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应急组织名称" prop="OrgianizationName">
          <el-input v-model="OrgianizationName"></el-input>
        </el-form-item>
        <el-form-item label class="right">
          <el-button @click="onSearch">查 询</el-button>
          <el-button @click="onCancel">清 理</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main style="padding-top:0px;">
      <zj-layout-container>
        <zj-layout-header>
          <div class="zj-button-bar">
            <el-button size="mini" @click="onAdd">添 加</el-button>
            <el-button size="mini" @click="onbatchDel">删 除</el-button>
          </div>
        </zj-layout-header>
        <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
          <el-table
            :data="tableData"
            ref="multipleTable"
            @selection-change="selectionChange"
            border
            style="width: 100%"
            height="100%"
          >
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="OrgianizationName" label="应急组织名称" align="center"></el-table-column>
            <el-table-column
              prop="ResourceTypeId"
              label="所属应急组织类型"
              :formatter="ConvertMaterialType"
              align="center"
            ></el-table-column>
            <el-table-column prop="OrgianiztionTypeId" label="组织性质" align="center"></el-table-column>
            <el-table-column label="操作" width="130" align="center">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button>
                <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </zj-layout-main>
      </zj-layout-container>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjPersonOrganiztionlist",
  controller: "EmergencyResource",
  action: "PersonOrganiztionlist",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      options: [],
      selectData: null,
      EmergencyType: "",
      OrgianizationName: "",
      OrgianiztionTypeDic: []
    };
  },
  created: function() {
    this.basedatabind().then(() => {
      this.search();
    });
    this.logInfo.ActionName = "应急组织结构查看";
    this.logInfo.LogMessage = "应急组织结构查看";
    this.logInfo.ModuleName = "应急系统";
    this.logInfo.PageName = "应急组织结构列表页面";
    this.addOperationLog();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      let searchInfo = {
        ResourceTypeId: this.EmergencyType,
        OrgianizationName: this.OrgianizationName,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      this.loading = true;
      this.loadingText = "加载中...";
      new MyApis.PersonOrganiztionApi()
        .GetPageContentByConditions(searchInfo)
        .then(r => {
          //console.log("1");
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    clearsearch() {
      this.EmergencyType = "";
      this.OrgianizationName = "";
    },
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = "加载中...";
      return utils
        .waitAll([
          this.config.getUValue("EmergencyService:PersonOrgianiztionType:", "")
        ])
        .then(r => {
          this.options = r[0].JValue;
          for (var i = 0; i < this.options.length; i++) {
            var item = this.options[i];
            this.OrgianiztionTypeDic[item.ItemKey] = item.Extend1;
          }

          this.loading = false;

          return r;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    ConvertMaterialType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.OrgianiztionTypeDic[data];
      return levelstr;
    },
    ConvertIsInOut(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      if (data == "1") {
        return "内部";
      }
      if (data == "2") {
        return "外部";
      }
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/PersonOrganiztioninfo",
        // name: 'mallList',
        query: {
          obj: row,
          type: "edit"
        }
      });
    },
    //查看详细
    handleClick(index, row) {
      //console.log(index, row);
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/PersonOrganiztioninfo",
        // name: 'mallList',
        query: {
          obj: row,
          type: "search"
        }
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/PersonOrganiztioninfo",
        // name: 'mallList',
        query: {
          obj: null,
          type: "edit"
        }
      });
    },
    //组织结构有人员存在，不能删除
    canDelete(selectData, callback) {
      let arr = [];
      for (let i = 0; i < selectData.length; i++) {
        new MyApis.AddressbookApi()
          .FindByConditions({
            PersonOrgianiztionId: selectData[i].PersonOrgianiztionId
          })
          .then(r => {
            var data = r.data.Data;
            if (data.length > 0) {
              this.$message.error(
                selectData[i].OrgianizationName +
                  "有人员存在，请先删除完人员才能删除组织机构"
              );
              arr.push({ isDelete: false });
            } else {
              arr.push({ isDelete: true });
            }
            callback(arr);
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          const selectData = this.selectData;
          const count = selectData.length;
          // 清除 所有勾选项
          this.$refs.multipleTable.clearSelection();
          if (count > 0) {
            const that = this;
            that.canDelete(selectData, function(data) {
              const index = data.findIndex(item => item.isDelete == false);
              if (index == -1 && data.length == count) {
                that.loading = true;
                that.loadingText = "删除中...";
                new MyApis.PersonOrganiztionApi()
                  .DelItemList(selectData)
                  .then(r => {
                    r = r.data.Data;
                    if (r) {
                      that.$message({
                        type: "success",
                        message: "删除成功!"
                      });
                    } else {
                      that.$message({
                        type: "error",
                        message: "删除失败!"
                      });
                    }
                    that.loading = false;
                    that.logInfo.ActionName = "应急组织结构删除";
                    that.logInfo.LogMessage = r?"应急组织结构删除成功":"应急组织结构删除失败";
                    that.logInfo.ModuleName = "应急系统";
                    that.logInfo.PageName = "应急组织结构列表页面";
                    that.addOperationLog();
                    that.search();
                  })
                  .catch(e => {
                    console.error(e);
                    that.errmsg(
                      e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！"
                    );
                    that.loading = false;
                  });
              } else {
                return;
              }
            });
          }
        });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const that = this;
        this.canDelete([row], function(data) {
          const index = data.findIndex(item => item.isDelete == false);
          if (index != -1) {
            return;
          } else {
            that.loading = true;
            that.loadingText = "删除中...";
            new MyApis.PersonOrganiztionApi()
              .DelItem(row)
              .then(r => {
                r = r.data.Data;
                if (r) {
                  that.$message({
                    type: "success",
                    message: "删除成功!"
                  });
                } else {
                  that.$message({
                    type: "error",
                    message: "删除失败!"
                  });
                }
                that.loading = false;
                that.logInfo.ActionName = "应急组织结构删除";
                that.logInfo.LogMessage = r?"应急组织结构删除成功":"应急组织结构删除失败";
                that.logInfo.ModuleName = "应急系统";
                that.logInfo.PageName = "应急组织结构列表页面";
                that.addOperationLog();
                that.search();
              })
              .catch(e => {
                console.error(e);
                that.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
                that.loading = false;
              });
          }
        });
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  }
};
</script>